import { createTypes, createAction } from 'lib/action'

// *load ข้อมูล service active log
const LOAD_SERVICE_ACTIVE_LOG = createTypes(
  'loadServiceActiveLog',
  'load'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลต้นแหล่ง
const loadServiceActiveLog = {
  request: (data, loading) =>
    createAction(LOAD_SERVICE_ACTIVE_LOG.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LOAD_SERVICE_ACTIVE_LOG.SUCCESS, { lists }),
  failure: () => createAction(LOAD_SERVICE_ACTIVE_LOG.FAITLURE),
}

export {
  LOAD_SERVICE_ACTIVE_LOG,
  loadServiceActiveLog,
  REMOVE_LISTS,
  removeLists,
}
